import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { SystemService } from 'src/app/core/system.service';

export interface Keylessons {
  id: number;
  completed: boolean;
  locked: boolean;
}

@Component({
  selector: 'app-keylesson-list',
  templateUrl: './keylesson-list.component.html',
  styleUrls: ['./keylesson-list.component.scss']
})
export class KeylessonListComponent implements OnInit {
  
  readonly numKeylessons = 8; //Array.from({length: 8}, (_, i) => i + 1)

  keyLessons: Keylessons[] = [];

  language: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private systemService: SystemService,
    private authService: AuthService) { }

  ngOnInit() {
    // if not on game mode
    if(!this.systemService.inGameMode$.value) { this.router.navigate(['']) };

    this.language = this.authService.user$.value.language_in_use;

    this.setupKeyLessons();

    this.authService.user$
      .subscribe(_ => {
        console.log('Updating key lessons...')
        this.setupKeyLessons();
      })

  }

  private setupKeyLessons() {
    const user = this.authService.user$.value;
    this.keyLessons = [];

    let lastCompleted = 0;
    for(var i = 1; i <= this.numKeylessons; i++) {
      const completed = user[`basicLesson${i}Complete`] === '1';

      if(completed) {
        lastCompleted = i;
      }

      this.keyLessons.push({
        id: i,
        completed: completed,
        locked: lastCompleted !== i - 1 && !completed
      })
    }

  }

  // view lesson
  view(lesson) {
    this.router.navigate([`${lesson.id}`], { relativeTo: this.route });
  }

}
